<div class="flex flex-row justify-between pb-10">
  <div class="flex flex-row">
    <mat-icon *ngIf="headerIcon" class="mr-16 icon-lg" [svgIcon]="headerIcon"></mat-icon>
    <div class="flex flex-col">
      <div class="mat-headline-5 mb-6 fw-700">{{ title }}</div>
      <div class="mat-body fw-500" [ngClass]="{'max-w-[300px]': subtitle?.length > 32}" [matTooltip]="subtitle?.length > 32 ? subtitle  : ''" matTooltipClass="tooltip-up" matTooltipPosition="above">{{ subtitle?.length > 32 ? (subtitle | slice:0:32) + '…' : subtitle }}</div>
    </div>
  </div>
  <mat-icon svgIcon="close" class="close-icon" (click)="sidenavService.closeRightSidenav()"></mat-icon>
</div>
<mat-divider class="mb-20 neutral-2"></mat-divider>